import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {
  
  private currentPixelId: string | null = null;

  constructor() {
  
   }

   // Método centralizado para inicializar el Pixel basado en el evento
  inicializarPixelSiEsNecesario(metaPixel: string | null | undefined): void {
    // Si metaPixel es null, undefined o una cadena vacía, no hacemos nada
    if (!metaPixel || metaPixel.trim() === '') {
      console.log('No se proporcionó un Meta Pixel válido. No se inicializará el Pixel.');
      return;
    }

    const metaPixelId = this.extraerMetaPixelId(metaPixel);
    if (!metaPixelId) {
      console.warn('El Meta Pixel no tiene un ID válido.');
      return;
    }
  
    // Si ya está inicializado con el mismo ID, no hacemos nada
    if (window['fbqInitialized'] && this.currentPixelId === metaPixelId) {
      console.log(`El Pixel con ID ${metaPixelId} ya está inicializado.`);
      return;
    }

    // Inicializamos el Pixel
    this.initPixel(metaPixelId);
    this.currentPixelId = metaPixelId; // Actualizamos el ID actual

  }

  initPixel(metaPixel: string): void {
    if (window.fbq) {
      // Si ya existe fbq pero no está inicializado con este ID, reiniciamos
      if (window['fbqInitialized'] && this.currentPixelId !== metaPixel) {
        window['fbqInitialized'] = false;
        window.fbq('consent', 'revoke');
      }

      // Inicializa el Meta Pixel con el nuevo ID
      window.fbq('init', metaPixel);
      window['fbqInitialized'] = true;
      window.fbq('track', 'PageView'); // Rastrear PageView después de inicializar

      } else {
      (function(f: any, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', metaPixel);
      window['fbqInitialized'] = true;
      window.fbq('track', 'PageView');
    }
  }
 
  trackEvent(event: string, parameters?: any): void {
    if (window.fbq && window['fbqInitialized']) {
      if (parameters) {
        window.fbq('track', event, parameters);
      } else {
        window.fbq('track', event);
      }
    } else {
      console.warn(`Meta Pixel no está inicializado. No se pudo rastrear el evento ${event}.`);
    }
  }

  trackInitialCheckout(): void {
    if (window['fbqInitialized']) {
      this.trackEvent('InitialCheckout');
      console.log('InitialCheckout enviado');
    } else {
      console.warn('El Meta Pixel no está inicializado. No se pudo rastrear el evento InitialCheckout.');
    }
  }

  trackPurchase(value: number, currency: string): void {
    if (window['fbqInitialized']) {
      this.trackEvent('Purchase', {
        value: value,
        currency: currency
      });
      console.log(`Purchase enviado - Valor: ${value}, Divisa: ${currency}`);
    } else {
      console.warn('El Meta Pixel no está inicializado. No se pudo rastrear el evento Purchase.');
    }
  }

  trackAddToCart(): void {
    if (window['fbqInitialized']) {
      this.trackEvent('AddToCart');
      console.log('AddToCart enviado');
    } else {
      console.warn('El Meta Pixel no está inicializado. No se pudo rastrear el evento AddToCart.');
    }
  }

  /**
   * @param metaPixel link metaPixel del evento.
   */
  extraerMetaPixelId(metaPixel: string): string {
    const regex = /tr\?id=(\d+)/; // Expresión regular para encontrar el ID dentro del link
    const match = metaPixel.match(regex); // Buscar coincidencias
    return match ? match[1] : null; // Devolver el ID si existe, de lo contrario null
  }

  /**
 * Detiene, borra el Meta Pixel y elimina el script
 * @returns void
 */
detenerYBorrarPixel(): void {
  if (window['fbqInitialized'] && window.fbq) {
    try {
      // Revocar el consentimiento
      window.fbq('consent', 'revoke');
      
      // Eliminar el script de Facebook
      const fbScript = document.querySelector('script[src*="facebook.net/en_US/fbevents.js"]');
      if (fbScript) {
        fbScript.parentNode.removeChild(fbScript);
      }
      
      // Eliminar los iframes de Facebook Pixel
      const fbIframes = document.querySelectorAll('iframe[src*="facebook.com"]');
      fbIframes.forEach(iframe => {
        iframe.parentNode.removeChild(iframe);
      });
      
      // Crear una versión inofensiva de fbq para evitar errores
      window.fbq = function() {
        console.log('Meta Pixel fue desactivado. Llamada a fbq ignorada.');
      };
      
      // Marcar como no inicializado
      window['fbqInitialized'] = false;
      
      // Resetear el ID actual
      this.currentPixelId = null;
      
      console.log('Meta Pixel detenido y script eliminado correctamente.');
    } catch (error) {
      console.error('Error al intentar detener el Meta Pixel:', error);
    }
  } else {
    console.log('No hay Meta Pixel inicializado para detener.');
  }
}
}
